module.exports = __webpack_public_path__ + "img/logo OGL.e8009299.png";